export default __webpack_public_path__ + "static/media/doctor-2.7efdab2a.jpg";